import {Component, OnInit, Input, HostListener} from '@angular/core';

@Component({
  selector: 'landing-carousel',
  templateUrl: './landing-carousel.component.html',
  styleUrls: ['./landing-carousel.component.scss']
})
export class LandingCarouselComponent implements OnInit {

  @Input() themes;
  @Input() insideModal;
  @Input() themeType;
  currentTheme;
  currentThemeIndex = 0;
  themesMaxIndex;

  constructor() { }

  ngOnInit() {
    this.currentTheme = this.themes[this.currentThemeIndex];
    this.themesMaxIndex = this.themes.length - 1;
  }

  @HostListener('window:keydown.ArrowLeft', ['$event'])
  previous() {
    this.currentThemeIndex--;
    if (this.currentThemeIndex < 0) {
      this.currentThemeIndex = this.themesMaxIndex;
    }
    this.changeTheme();
  }

  @HostListener('window:keydown.ArrowRight', ['$event'])
  next() {
    this.currentThemeIndex++;
    if (this.currentThemeIndex > this.themesMaxIndex) {
      this.currentThemeIndex = 0;
    }
    this.changeTheme();
  }

  changeTheme() {
    this.currentTheme = this.themes[this.currentThemeIndex];
  }

}
